document.addEventListener('DOMContentLoaded', function () {
  var backButton = document.querySelector('.button--back');
  if (backButton) {
    if (typeof history !== 'undefined' && typeof history.back === 'function' && history.length > 1) {
      const isClick = localStorage.getItem("search_click_from");

      backButton.querySelector("span").textContent = window.productStrings.backButton;
      backButton.addEventListener('click', function (event) {
        event.preventDefault();
        // history.back();
        if (isClick == 'false') {
          history.back();
        } else {
          const searchBar = document.querySelector('.modal__toggle');
          searchBar.click();
          const checkExist = setInterval(function() {
            const inputElement = document.querySelector('.dfd-searchbox-input');
            
            if (inputElement) {
              const lastSearch = localStorage.getItem('search_value', inputElement.value)
              inputElement.value = lastSearch;

              var inputEvent = new Event('input', {
                  bubbles: true,
                  cancelable: true,
              });
              inputElement.dispatchEvent(inputEvent);
              clearInterval(checkExist);
            }
          }, 100);
        }

      });
    }
    backButton.querySelector("span").classList.remove("hidden");
  }
});